export class DayPelletizingProductionQualityItem {
  constructor({
        id= null, 
        parameterName= ``, 
        parameterCode= ``,
        parameterUnit= ``,          
        sampleName='',
        sampleCode= ``,
        upValue='',
        downValue='',
        checkValue='',
        qualityResult='',
    } = {}) {
    this.id = id;
    this.parameterName = parameterName;
    this.dparameterCodeay = parameterCode;
    this.parameterUnit = parameterUnit;     
    this.sampleName = sampleName;  
    this.sampleCode = sampleCode;
    this.upValue = upValue;
    this.downValue = downValue;
    this.checkValue=checkValue;
    this.qualityResult=qualityResult;

  }
}
export function gridFields() {
  return Object.freeze(
      [
      
      
      
      {
        key: 'sampleName',
        label: 'lbl.qualityResult.sampleName',
        sortable: true,
        notInTable:true,
        form: {
          type: 'input'
        }
      },  
 
      {
        key: 'parameterName',
        label: 'lbl.qualityResult.parameterName',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'parameterCode',
        label: 'lbl.qualityResult.parameterCode',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'upValue',
        label: 'lbl.qualityResult.upValue',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'downValue',
        label: 'lbl.qualityResult.downValue',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'checkValue',
        label: 'lbl.qualityResult.checkValue',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'parameterUnit',
        label: 'lbl.qualityResult.parameterUnit',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      
          
     
  ]);
}
export const fields = Object.freeze(Object.keys(new DayPelletizingProductionQualityItem()).map(i => 'entity.' + i));
export const filterFields = [
   
];
export const filter = {

};